import { authHeaders } from "./api";

/** Fetch a protected endpoint (with auth) as a Blob, resolving the filename from
 *  Content-Disposition when present. Used by both download and share. */
export async function fetchExport(
  path: string,
  fallbackName: string,
): Promise<{ blob: Blob; filename: string }> {
  const res = await fetch(path, { headers: authHeaders() });
  if (!res.ok) {
    let msg = res.statusText || "Download failed";
    try {
      const j = await res.json();
      if (typeof j.detail === "string") msg = j.detail;
    } catch {}
    throw new Error(msg);
  }
  const blob = await res.blob();
  let filename = fallbackName;
  const cd = res.headers.get("Content-Disposition");
  if (cd) {
    const m = cd.match(/filename="?([^";]+)"?/);
    if (m) {
      try { filename = decodeURIComponent(m[1]); } catch { filename = m[1]; }
    }
  }
  return { blob, filename };
}

/** Trigger a browser "save file" for a Blob. Works in a normal browser and in
 *  most Telegram WebViews. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

/** Fetch an export endpoint and trigger a download. */
export async function downloadExport(path: string, fallbackName: string): Promise<void> {
  const { blob, filename } = await fetchExport(path, fallbackName);
  saveBlob(blob, filename);
}

/** Fetch a protected file (with auth header) and return an object URL (for <img>). */
export async function fetchBlobUrl(path: string): Promise<string> {
  const res = await fetch(path, { headers: authHeaders() });
  if (!res.ok) throw new Error(res.statusText || "fetch failed");
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
